// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productSearchScoreDataStyles } from "@tps/Overrides/Components/ProductSearchScoreData";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { ellipsis, styledScrollbar } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productSearchScoreDataStyles.dataTable = {
    mergeCss: true,
    css: css`
        &,
        ${TypographyStyle} {
            font-size: 14px;
            line-height: 22px;
        }
    `,
};

productSearchScoreDataStyles.cellLabel = {
    mergeCss: true,
    css: css`
        max-width: 70px;
        min-width: 70px;
        white-space: pre-wrap;
        ${TypographyStyle} {
            font-size: 14px;
            line-height: 22px;
            font-weight: ${fontConfig.weight.bold};
            ${ellipsis(1)}
        }
    `,
};
productSearchScoreDataStyles.accordionSection = {
    panelProps: {
        css: css`
            > div {
                overflow-x: auto;
                ${styledScrollbar(4)}
            }
            [class^="Wrapper"]::after {
                display: none;
            }
        `,
    },
};

productSearchScoreDataStyles.aggregateFieldScoresWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productSearchScoreDataStyles.dataValueTypography = {
    css: css`
        display: block;
        white-space: nowrap;
    `,
};
